export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Onboarding post-inscription
  CREATE_CLUB_ONBOARDING: '/creer-mon-club',
  CREATE_ORG_ONBOARDING: '/creer-mon-organisation',
  VERIFY_EMAIL: '/verify-email',
  AUTH_CALLBACK: '/auth/callback',
  OAUTH_ONBOARDING: '/auth/onboarding',

  // Front pages
  FRONT_SUPPORT: '/support/',
  FRONT_POLITIQUE_RGPD: '/politique-rgpd/',
  FRONT_CGU_CGV: '/cgu-cgv/',

  // Super Admin
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_EDIT: '/admin/users/:id/edit',
  ADMIN_CLUBS: '/admin/clubs',
  ADMIN_ORGANIZERS: '/admin/organizers',
  ADMIN_COMPETITIONS: '/admin/competitions',
  ADMIN_PAYMENTS: '/admin/payments',
  ADMIN_REFUND_REQUESTS: '/admin/refund-requests',
  ADMIN_FEEDBACK: '/admin/feedback',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_BLOG: '/admin/blog',
  ADMIN_BLOG_CREATE: '/admin/blog/create',
  ADMIN_BLOG_EDIT: '/admin/blog/:id/edit',
  ADMIN_SAAS_PARAMS: '/admin/saas-params',
  ADMIN_GDPR_TREATMENTS: '/admin/gdpr/treatments',
  ADMIN_GDPR_BREACHES: '/admin/gdpr/breaches',
  ADMIN_QUEUES: '/admin/queues',

  // Organisateur
  ORGANIZER_DASHBOARD: '/organizer/dashboard',
  ORGANIZER_INSCRIPTIONS: '/organizer/inscriptions',
  ORGANIZER_CLUBS: '/organizer/clubs',
  ORGANIZER_PAYMENTS: '/organizer/payments',
  ORGANIZER_ANALYTICS: '/organizer/analytics',
  ORGANIZER_PROFILE_EDIT: '/organizer/profile/edit',
  ORGANIZER_SETTINGS: '/organizer/settings',
  ORGANIZER_REFUND_REQUESTS: '/organizer/refund-requests',
  ORGANIZER_ADMIN_REQUESTS: '/organizer/admin-requests',
  ORGANIZER_BLOG: '/organizer/blog',
  ORGANIZER_SITE_CMS: '/organizer/site',
  ORGANIZER_BLOG_CREATE: '/organizer/blog/create',
  ORGANIZER_BLOG_EDIT: '/organizer/blog/:id/edit',

  // Concours (organisateur)
  COMPETITION_LIST: '/competition/list',
  COMPETITION_CREATE: '/competition/create',
  COMPETITION_EDIT: '/competition/:id/edit',
  COMPETITION_RESULTS_ENTRY: '/competition/:id/results',

  // Club
  CLUB_DASHBOARD: '/club/dashboard',
  CLUB_MEMBERS: '/club/members',
  CLUB_TEAMS: '/club/teams',
  CLUB_COMPETITIONS: '/club/competitions',
  CLUB_INSCRIPTIONS: '/club/inscriptions',
  CLUB_HISTORY: '/club/history',
  CLUB_ANALYTICS: '/club/analytics',
  CLUB_ORGANIZERS: '/club/organizers',
  CLUB_PROFILE_EDIT: '/club/profile/edit',
  CLUB_SETTINGS: '/club/settings',
  CLUB_BLOG: '/club/blog',
  CLUB_SITE_CMS: '/club/site',
  CLUB_BLOG_CREATE: '/club/blog/create',
  CLUB_BLOG_EDIT: '/club/blog/:id/edit',

  // Joueur
  PLAYER_DASHBOARD: '/player/dashboard',
  PLAYER_INSCRIPTIONS: '/player/inscriptions',
  PLAYER_CLUB: '/player/club',
  PLAYER_HISTORY: '/player/history',
  PLAYER_STATS: '/player/stats',
  PLAYER_PROFILE: '/player/profile',
  PLAYER_PREFERENCES: '/player/preferences',

  // Profil / Sécurité
  PROFILE_SECURITY: '/profile/security',
} as const;
